import Vue from 'vue';

export default {
	getSuggestions(query, attribut) {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.TAGGER_URL, {
				S_Attribut: attribut,
				S_Type: 'tag',
				field: 'PKM_Objekt',
				query,
			})
			.then((response) => {
				if (response.body.status === 'success') {
					resolve(response.body);
				} else {
					reject(response);
				}
			})
			.catch((response) => {
				reject(response);
			});
		});
	},

	setTag(id, tag, tagvals) {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.TAGGER_URL,
						  { S_Attribut: tagvals.S_Attribut,
						    S_Type: tagvals.S_Type,
						    field: 'PKM_Objekt',
						    foreignkey: id,
						    S_Value: tagvals.S_Value,
						    mode: 'set' })
			.then((response) => {
				resolve(response);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},

	deleteTag(tagID) {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.TAGGER_URL, { PKM_Tag: tagID, mode: 'deltag' })
			.then((response) => {
				resolve(response);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},

	getTags(id) {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.TAGGER_URL,
						  {
						    field: 'PKM_Objekt',
						    foreignkey: id,
						    mode: 'get' })
			.then((response) => {
				resolve(response.body);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},
};



// WEBPACK FOOTER //
// ./src/api/tagger.js